(function () {
  function getYouTubeEmbedUrl(url) {
    const match = url.match(
      /(?:youtube\.com\/(?:watch\?v=|embed\/|shorts\/)|youtu\.be\/)([a-zA-Z0-9_-]{11})/,
    );
    if (match) {
      return "https://www.youtube-nocookie.com/embed/" + match[1];
    }
    return null;
  }

  function normalizeYouTubeLinks(scope) {
    scope
      .querySelectorAll('[data-fancybox][data-type="iframe"]')
      .forEach((el) => {
        const normalized = getYouTubeEmbedUrl(el.getAttribute("href"));
        if (normalized) {
          el.setAttribute("href", normalized);
        }
      });
  }

  function initFancybox(scope) {
    if (typeof Fancybox === "undefined") {
      setTimeout(() => initFancybox(scope), 100);
      return;
    }
    Fancybox.destroy();
    normalizeYouTubeLinks(scope);
    Fancybox.bind("[data-fancybox]", {
      groupAll: false,
      Thumbs: false,
      Toolbar: {
        display: {
          left: [],
          middle: [],
          right: ["close"],
        },
      },
    });
  }

  function getSectionEl(sectionId) {
    return document.querySelector(
      `.advanced-multicolumn[data-section-id="${sectionId}"], .video-testimonials[data-section-id="${sectionId}"]`,
    );
  }

  function getLightboxSections(scope) {
    return scope.querySelectorAll(
      ".advanced-multicolumn[data-section-id], .video-testimonials[data-section-id]",
    );
  }

  document.addEventListener("DOMContentLoaded", () => {
    getLightboxSections(document).forEach((el) => initFancybox(el));
  });

  document.addEventListener("shopify:section:load", (e) => {
    getLightboxSections(e.target).forEach((el) => initFancybox(el));
  });

  document.addEventListener("shopify:block:select", (e) => {
    const el = getSectionEl(e.detail.sectionId);
    if (el) initFancybox(el);
  });
})();
